import React from 'react';
import { Typography, theme } from 'antd';

export interface CapabilityItem {
  title: string;
  description: string;
}

export interface FeatureItem {
  title: string;
  description: string;
  icon: React.ReactNode;
}

interface ExpandedCapabilitiesProps {
  dataCapabilities: CapabilityItem[];
  enabledFeatures: FeatureItem[];
  emptyMessage: string;
  headerExtra?: React.ReactNode;
}

const ExpandedCapabilities: React.FC<ExpandedCapabilitiesProps> = ({
  dataCapabilities,
  enabledFeatures,
  emptyMessage,
  headerExtra,
}) => {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        marginTop: token.marginXS,
        borderRadius: token.borderRadiusLG,
        paddingLeft: token.paddingSM,
        paddingRight: token.paddingSM,
        paddingTop: token.paddingXS,
        paddingBottom: token.paddingXS,
        backgroundColor: token.colorFillQuaternary,
      }}
    >
      {/* Header row */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography.Text strong type="secondary" style={{ fontSize: token.fontSizeSM }}>
          Data Capabilities{dataCapabilities.length > 0 ? ` (${dataCapabilities.length})` : ''}
        </Typography.Text>
        {headerExtra}
      </div>
      <div style={{ marginBottom: token.marginXXS }} />
      {dataCapabilities.length > 0 ? (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            rowGap: token.marginXS,
            columnGap: token.marginMD,
          }}
        >
          {dataCapabilities.map((cap) => (
            <div key={cap.title}>
              <Typography.Text>{cap.title}</Typography.Text>
              <br />
              <Typography.Text style={{ fontSize: token.fontSizeSM, color: token.colorTextLabel }}>
                {cap.description}
              </Typography.Text>
            </div>
          ))}
        </div>
      ) : (
        <Typography.Text
          type="secondary"
          style={{
            fontSize: token.fontSizeSM,
            display: 'block',
            padding: `${token.paddingXS}px 0`,
          }}
        >
          {emptyMessage}
        </Typography.Text>
      )}

      {/* Features */}
      {enabledFeatures.length > 0 && (
        <>
          <div
            style={{
              borderTop: `1px solid ${token.colorBorderSecondary}`,
              marginTop: token.marginXS,
              marginBottom: token.marginXS,
            }}
          />
          <Typography.Text strong type="secondary" style={{ fontSize: token.fontSizeSM }}>
            Features ({enabledFeatures.length})
          </Typography.Text>
          <div style={{ marginBottom: token.marginXXS }} />
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              rowGap: token.marginXS,
              columnGap: token.marginMD,
            }}
          >
            {enabledFeatures.map((feat) => (
              <div key={feat.title}>
                <div style={{ display: 'flex', alignItems: 'center', gap: token.marginXXS }}>
                  <span style={{ display: 'inline-flex', color: token.colorText }}>
                    {feat.icon}
                  </span>
                  <Typography.Text>{feat.title}</Typography.Text>
                </div>
                <Typography.Text
                  style={{ fontSize: token.fontSizeSM, color: token.colorTextLabel }}
                >
                  {feat.description}
                </Typography.Text>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ExpandedCapabilities;
